/* Built In Imports */

/* External Imports */
import { Box, Flex, Heading, Show } from '@chakra-ui/react';
// import copy from 'copy-to-clipboard';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import { ProgramFeeSt } from '@ieo/Common/CompLangConfig';
import SingleImage from './SingleImage';

/* Services */
/* Styles */

/**
 *
 * @param {Object} prgData
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @param {Object} pageData
 * @returns ProgramFee
 */
const ProgramFeeV8 = ({ sectionContent, region, lang, prgData, pageData }) => {
  return (
    <Box bg="#F1EBDF" position={'relative'}>
      <SingleImage
        display={{ base: 'none', md: 'block' }}
        sectionContent={sectionContent[15]}
        position="absolute"
        objectPosition="bottom"
        top={{ base: 'auto' }}
        bottom={{ base: '0' }}
        left="0"
        my="0px"
        px="0px"
        lang={lang}
        w={{ base: '100%', md: '100%', lg: '100%' }}
        h={{ base: '100%', md: '100%', lg: '100%' }}
        maxW={{ base: '100%', md: '10%', xl: '13%', '2xl': '15%' }}
        maxWidthPx={767}
        lineHeight="0px"
      />
      <SingleImage
        display={{ md: 'block' }}
        sectionContent={sectionContent[16]}
        position="absolute"
        objectPosition="bottom"
        top={{ base: '0' }}
        bottom={{ base: 'auto' }}
        right="0"
        my="0px"
        px="0px"
        lang={lang}
        w={{ base: '100%', md: '100%', lg: '100%' }}
        h={{ base: '100%', md: '100%', lg: '100%' }}
        maxW={{ base: '100%', md: '15%', lg: '15%' }}
        maxWidthPx={767}
        lineHeight="0px"
      />
      <Flex
        maxW={1030}
        bgRepeat="no-repeat"
        pt={{ base: '60px', md: '73px' }}
        id="ieo-program-fees"
        mx="auto"
      >
        <Flex w="full" mx="auto" flexWrap="wrap" px={{ base: '16px', xl: 0 }}>
          <Flex
            w="full"
            px={{ base: '0', xl: 0 }}
            flexDir={{ base: 'column', lg: 'row' }}
            justifyContent="space-between"
            gridGap={{ base: '30px', lg: '70px' }}
            css={{
              '-webkit-grid-gap': '40px',
              '@media screen and (min-width: 768px)': {
                '-webkit-grid-gap': '70px',
              },
            }}
            pb={{ base: '40px', md: '73px' }}
          >
            <Box
              color="#fff"
              w={{
                base: '100%',
                md: '60%',
                lg: '80%',
                xl: '60%',
                '2xl': '60%',
              }}
              display="flex"
              justifyContent="flex-start"
              flexDirection="column"
              alignItems={lang === 'ar' ? 'flex-end' : 'flex-start'}
              pt={{ base: '0', lg: '146px' }}
            >
              <Heading as="h2" {...ProgramFeeSt[lang].h2} color="#3B444B">
                {sectionContent?.[0]?.titleText}
              </Heading>
              <StructuredTextParser
                mt="10px"
                str={render(sectionContent?.[1].body)}
                {...ProgramFeeSt[lang].p}
                maxW="auto"
                color="#3B444B"
                fontSize={{ base: '20px', md: '26px' }}
              />
              <StructuredTextParser
                mt="10px"
                str={render(sectionContent?.[2].body)}
                {...ProgramFeeSt[lang].p1}
                maxW="auto"
                color="#3B444B"
                fontSize={{ base: '20px', md: '24px' }}
              />
            </Box>

            <Flex flexDir="column" maxW="539px" mx="auto">
              <Flex
                bg="#fff !important"
                flexGrow="1"
                pt={{ base: '25px', md: '56px' }}
                pb={{ base: '35px', md: '56px' }}
                px={{ base: '16px', md: '46px' }}
                flexDir="column"
                zIndex={'2'}
              >
                <Flex
                  alignItems={{ base: 'flex-start', md: 'top' }}
                  gridGap={{ base: '13px', md: '16px' }}
                  css={{ '-webkit-grid-gap': '20px' }}
                >
                  <Flex>
                    <Box display={{ base: 'none', md: 'block' }}>
                      <svg
                        width="31"
                        height="31"
                        viewBox="0 0 31 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.0391 8.20866H16.9557V11.1253H14.0391V8.20866ZM14.0391 14.042H16.9557V22.792H14.0391V14.042ZM15.4974 0.916992C7.4474 0.916992 0.914062 7.45033 0.914062 15.5003C0.914062 23.5503 7.4474 30.0837 15.4974 30.0837C23.5474 30.0837 30.0807 23.5503 30.0807 15.5003C30.0807 7.45033 23.5474 0.916992 15.4974 0.916992ZM15.4974 27.167C9.06615 27.167 3.83073 21.9316 3.83073 15.5003C3.83073 9.06908 9.06615 3.83366 15.4974 3.83366C21.9286 3.83366 27.1641 9.06908 27.1641 15.5003C27.1641 21.9316 21.9286 27.167 15.4974 27.167Z"
                          fill="#E86F34"
                        />
                      </svg>
                    </Box>
                    <Box display={{ base: 'block', md: 'none' }}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                          fill="#F37021"
                        />
                      </svg>
                    </Box>
                  </Flex>
                  <StructuredTextParser
                    id="program-fee-text"
                    mt="0"
                    str={render(sectionContent?.[3].body)}
                    {...ProgramFeeSt[lang].feeDiscount1}
                    maxW="auto"
                    color="#6D6358"
                    fontWeight={450}
                    lineHeight={{ base: '20px', md: '28px' }}
                  />
                </Flex>
                <Box
                  borderBottom={{
                    base: '1px solid #6D6358',
                    md: '2px solid #6D6358',
                  }}
                  opacity={0.3}
                  mt={{ base: '18px', md: '27px' }}
                />
                <Flex
                  flexDir="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <StructuredTextParser
                    str={render(sectionContent?.[4].body)}
                    id="fee-price"
                    maxW="none"
                    {...ProgramFeeSt[lang].regionalLanguages}
                    m={{
                      base: '35px 0 0 0 !important',
                      md: '25px 0 0 0 !important',
                    }}
                    fontSize="26px"
                    lineHeight="28px"
                    color="#6D6358"
                  />
                  <Flex
                    mt={{ base: '0px', md: '26px' }}
                    w="100%"
                    justifyContent={{ base: 'center', md: 'space-between' }}
                    flexDirection={{ base: 'column', md: 'row' }}
                    alignItems={{ base: 'center', md: 'center' }}
                    gap={{ base: '0px', md: '10px' }}
                  >
                    <StructuredTextParser
                      str={render(sectionContent?.[5].body)}
                      maxW="auto"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount2}
                      color="#6D6358"
                      fontSize={{
                        base: '26px',
                        md: '40px',
                        lg: '42px',
                        xl: '50px',
                      }}
                      lineHeight={{ base: '28px', md: '50px' }}
                      m={{
                        base: '11px 0 0 0 !important',
                        md: '0px !important',
                      }}
                    />

                    <StructuredTextParser
                      id={`${region}-${lang}-dis-price`}
                      str={render(sectionContent?.[6].body)}
                      maxW="none"
                      {...ProgramFeeSt[lang].feeDiscount3}
                      color="#CD9F00"
                      fontSize={{
                        base: '32px',
                        md: '30px',
                        lg: '32px',
                        xl: '36px',
                      }}
                      lineHeight={{ base: '34px', md: '50px' }}
                      m={{
                        base: '11px 0 0 0 !important',
                        md: '0px !important',
                      }}
                    />
                  </Flex>
                  <StructuredTextParser
                    str={render(sectionContent?.[7]?.body)}
                    id="fee-price"
                    maxW="none"
                    {...ProgramFeeSt[lang].regionalLanguages}
                    fontSize="26px"
                    lineHeight="28px"
                    color="#6D6358"
                    m={{
                      base: '27px 0 0 0 !important',
                      md: '42px 0 0 0 !important',
                    }}
                  />
                  <Flex
                    mt={{ base: '0px', md: '26px' }}
                    w="100%"
                    justifyContent={{ base: 'center', md: 'space-between' }}
                    flexDirection={{ base: 'column', md: 'row' }}
                    alignItems={{ base: 'center', md: 'center' }}
                    gap={{ base: '0px', md: '10px' }}
                  >
                    <StructuredTextParser
                      str={render(sectionContent?.[8].body)}
                      maxW="auto"
                      textDecoration="line-through"
                      {...ProgramFeeSt[lang].feeDiscount2}
                      color="#6D6358"
                      fontSize={{
                        base: '26px',
                        md: '40px',
                        lg: '42px',
                        xl: '50px',
                      }}
                      lineHeight={{ base: '28px', md: '50px' }}
                      m={{
                        base: '11px 0 0 0 !important',
                        md: '0px !important',
                      }}
                    />

                    <StructuredTextParser
                      id={`${region}-${lang}-dis-price`}
                      str={render(sectionContent?.[9].body)}
                      maxW="none"
                      {...ProgramFeeSt[lang].feeDiscount3}
                      color="#CD9F00"
                      fontSize={{
                        base: '32px',
                        md: '30px',
                        lg: '32px',
                        xl: '36px',
                      }}
                      lineHeight={{ base: '34px', md: '50px' }}
                      m={{
                        base: '11px 0 0 0 !important',
                        md: '0px !important',
                      }}
                    />
                  </Flex>
                </Flex>
              </Flex>
              <Flex>
                {searchByFieldId(sectionContent, 'pricing-includes-field') && (
                  <StructuredTextParser
                    str={render(
                      searchByFieldId(sectionContent, 'pricing-includes-field')
                        .body
                    )}
                    region={region}
                    lang={lang}
                    fontSize="16px"
                    fontFamily="FedraSansStd-book-i"
                    color="#000"
                    textAlign={{ base: 'center', md: 'start' }}
                    w="100%"
                    className="pricing_info"
                  />
                )}
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <style global>
          {`
            .thanksgiving:hover svg {
              fill: #E86F34;
              color: #E86F34;
            }
            .thanksgiving:hover {
              background: '#FAE4B8';
              color: '#FFFFFF';
            }
              .pricing_info p:last-child{
                padding-top: 15px;
              }
                .pricing_info p:first-child{
                padding-bottom: 20px;
              }
                @media (width >= 768px){
                  .pricing_info p:last-child{
                padding-top: 18px;
              }
                .pricing_info p:first-child{
                padding-bottom: 18px;
              }
                }
                .pricing_info strong {
                  font-style: normal;
                  font-family: FedraSansStd-book;
                }
              `}
        </style>
      </Flex>
    </Box>
  );
};

export default ProgramFeeV8;
